
export class MainMenu {

    private static _topItems: AMainMenuItem[] = [];
    private static _bottomItems: AMainMenuItem[] = [];

    public static registerTopItem(item: AMainMenuItem) {
        if (item == null) {
            throw new Error("The item parameter can not be null!");
        }
        this._topItems.push(item);
    }

    public static registerBottomItem(item: AMainMenuItem) {
        if (item == null) {
            throw new Error("The item parameter can not be null!");
        }
        this._bottomItems.push(item);
    }

    public static get topItems() {
        return this._topItems;
    }

    public static get bottomItems() {
        return this._bottomItems;
    }

    private constructor() {}

}

export abstract class AMainMenuItem {

    private _title: string;
    private _icon: string;

    public constructor(title: string , icon: string) {
        this._title = title;
        this._icon = icon;
    }

    public get title() {
        return this._title;
    }

    public get icon() {
        return this._icon;
    }

}

export class MainMenuLeafItem extends AMainMenuItem {

    private _url: string;

    public constructor(title: string , icon: string, url: string) {
        super(title, icon);
        this._url = url;
    }

    public get url() {
        return this._url;
    }

}

export class MainMenuGroupItem extends AMainMenuItem {

    private _children: MainMenuSubItem[] = [];

    public constructor(title: string , icon: string, children: MainMenuSubItem[]) {
        super(title, icon);
        this._children = children;
    }

    public get children() {
        return this._children;
    }

}

export class MainMenuSubItem {

    private _title: string;
    private _url: string;

    public constructor(title: string, url: string) {
        this._title = title;
        this._url = url;
    }

    public get title() {
        return this._title;
    }

    public get url() {
        return this._url;
    }

}